import closeImg from "../../../assets/close.png";
import "./style.css";

const HeaderRegister = (props) => {
	return (
		<header className="header-register ">
			{props.handleCloseModal && (
				<button type="button" onClick={props.handleCloseModal} className="modal-close-form">
					<img src={closeImg} alt="" />
				</button>
			)}
			<h2 className="title">{props.title}</h2>
			<h6 className="sub-title">{props.subTitle}</h6>
		</header>
	);
};

export default HeaderRegister;
